/* node_modules */
import React, { useMemo } from 'react';

import { visibilityFilter } from '~/helpers/data';

import styles from './StreamList.scss';
import { StreamPreview } from './StreamPreview';

interface StreamListProps {
  items: Stream[];
  adultToggleState: any;
  sortFollowedFirst?: boolean;
}

const StreamList: React.FC<StreamListProps> = ({
  items,
  adultToggleState,
  sortFollowedFirst = false,
}) => {
  const data = useMemo(() => {
    if (sortFollowedFirst) {
      items.sort((a, b) => {
        if (a.following?.value && !b.following?.value) {
          return -1;
        }
        if (!a.following?.value && b.following?.value) {
          return 1;
        }
        return 0;
      });
    }
    return visibilityFilter(items, adultToggleState);
  }, [items, adultToggleState, sortFollowedFirst]);

  return (
    <div className="StreamList-Container">
      <div className={styles.StreamList}>
        {data.map((stream) => (
          <StreamPreview key={stream.id} stream={stream} />
        ))}
      </div>
    </div>
  );
};

export default StreamList;
